import { connect } from 'react-redux';

import { changeCommitmentDetailsModalVisibility } from '../actions';
import { CommitmentDetailsModal } from '../components/CommitmentDetailsModal';

const mapStateToProps = (state, props) => {
  const { commitmentMonths } = props;

  return {
    isOpen: state.commitmentDetailsIsOpen,
    commitmentMonths,
  };
};

const mapDispatchToProps = dispatch => ({
  toggleModal: value => {
    dispatch(changeCommitmentDetailsModalVisibility(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommitmentDetailsModal);
